import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/pdmarketzlogo.png";
import { FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import instagramIcon from "../assets/instagram.png";
import facebookIcon from "../assets/facebook.png";
import linkedinIcon from "../assets/linkedin.png";

function Footer() {
  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <div className="footer-col footer-about">
          <div className="footer-logo">
            <Link to="/"><img src={logo} alt="PD Marketz logo" /></Link>
          </div>
          <p>We help businesses grow with result-driven digital marketing strategies including SEO, paid ads, and content marketing.</p>
          <div className="footer-social">
            <a href="https://www.instagram.com/pdmarketz/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <img src={instagramIcon} alt="Instagram" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61578137099134" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <img src={facebookIcon} alt="Facebook" />
            </a>
            <a href="https://www.linkedin.com/search/results/all/?fetchDeterministicClustersOnly=true&heroEntityKey=urn%3Ali%3Aorganization%3A107952573&keywords=pd%20marketz" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <img src={linkedinIcon} alt="LinkedIn" />
            </a>
          </div>
        </div>
        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            <li><Link to="/seo-services-delhi-ncr">Search Engine Optimization</Link></li>
            <li><Link to="/ppc-services-delhi-ncr">Pay Per Click (PPC)</Link></li>
            <li><Link to="/social-media-marketing-delhi-ncr">Social Media Marketing</Link></li>
            <li><Link to="/content-marketing-services-delhi-ncr">Content Marketing</Link></li>
            <li><Link to="/email-marketing-services-delhi-ncr">Email Marketing</Link></li>
            <li><Link to="/ecommerce-services-delhi-ncr">Ecommerce Marketing</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/blog">Blogs</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Get in Touch</h4>
          <ul className="contact-list">
            <li><FiMail /><a href="mailto:officialpdmarketz@gmail.com">officialpdmarketz@gmail.com</a></li>
            <li><FiPhone /><a href="tel:+919871423482">+91 98714 23482</a></li>
            <li><FiMapPin /><span>New Delhi, India</span></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 PD Marketz. All rights reserved.</p>
        <div className="footer-legal">
          <span>Privacy Policy</span><span>|</span><span>Terms &amp; Conditions</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
